export default __webpack_public_path__ + "static/media/congratsKetogo.d5cc3ed9.svg";